// @flow
import memoize from 'lodash.memoize';

import type {TreeRowData} from '../typedef';

type RowWithAdditionalRowsType<DataRow> = Array<{
    ...TreeRowData<DataRow>,
    additionalRows?: Array<TreeRowData<DataRow>>,
}>;

export const getAdditionalRows: <DataRow>(rows: Array<TreeRowData<DataRow>>) => RowWithAdditionalRowsType<DataRow> =
    memoize<
    Array<Array<TreeRowData<Object>>>,
    RowWithAdditionalRowsType<Object>
>(<DataRow>(rows: Array<TreeRowData<DataRow>>): RowWithAdditionalRowsType<DataRow> => {
    const withChildren = rows.reduce((prev, next) => {
        if (next.children) {
            prev.push(next);
        }
        return prev;
    }, []);

    return rows
        .map((row, i) => {
            const rowIndex = withChildren.indexOf(row);
            const pushAdditionalRows = () => {
                if (rowIndex + 1 === withChildren.length) {
                    return row;
                }

                const nextWithChildren = rows.find(el => el === withChildren[rowIndex + 1]);
                const nextWithChildrenIndex = nextWithChildren ? rows.indexOf(nextWithChildren) : 0;

                return ({...row, additionalRows: rows.slice(i + 1, nextWithChildrenIndex)});
            };

            return rowIndex === -1 ? null : pushAdditionalRows();
        })
        .filter(Boolean);
});

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../typedef");
